import { render, staticRenderFns } from "./commodityEdit.vue?vue&type=template&id=f0c63196&scoped=true"
import script from "./commodityEdit.vue?vue&type=script&lang=js"
export * from "./commodityEdit.vue?vue&type=script&lang=js"
import style0 from "./commodityEdit.vue?vue&type=style&index=0&id=f0c63196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c63196",
  null
  
)

export default component.exports